/**
 *
 * 2106105200 => 210 61 05 200
 *
 * @param {String} s Phone Number
 */

function phone(s) {
  //s2 = s2.replace(/^\+/, '').replace(/^30/, '')
  //s2 = s2.replace(/^\+/, '').replace(/^357/, '')
  //const s2 = ('' + s).replace(/\D/g, '')
  const m = s?.match(/^(\+\d{2}|00{4})?(\d{3})(\d{2})(\d{2})(\d+)$/)

  if (!m) return s

  const p1 = m[1] ? m[1] + ' ' : ''
  const p2 = m[2] ? m[2] + ' ' : ''
  const p3 = m[3] ? m[3] + ' ' : ''
  const p4 = m[4] ? m[4] + ' ' : ''
  const p5 = m[5] ? m[5] + '' : ''

  return m ? (p1 + p2 + p3 + p4 + p5) : s
}

export default phone
